import moment, { Moment } from 'moment';

export default {
  fixIOSScroll(): void {
    const ua = window.navigator.userAgent;
    if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      window.scroll(0, 0);
    }
  },
  disabledDate(current: Moment) {
    return current && current > moment().endOf('day');
  },
  formatDraftDataInStep1(draftInfo: any) {
    return {
      name: draftInfo.name ? draftInfo.name : undefined,
      enName: draftInfo.enName ? draftInfo.enName : undefined,
      pinyinLastName: draftInfo.pinyinLastName ? draftInfo.pinyinLastName : undefined,
      pinyinFirstName: draftInfo.pinyinFirstName ? draftInfo.pinyinFirstName : undefined,
      gender: draftInfo.gender ? draftInfo.gender : undefined,
      birthday: draftInfo.birthday ? moment(draftInfo.birthday) : undefined,
      idType: draftInfo.idType ? draftInfo.idType : undefined,
      idNumber: draftInfo.idNumber ? draftInfo.idNumber : undefined,
      countryId: draftInfo.countryId ? draftInfo.countryId : undefined,
      address: draftInfo.address ? draftInfo.address : undefined,
      domicileAddress: draftInfo.domicileAddress ? draftInfo.domicileAddress : undefined,
      campusId: draftInfo.campusId&&draftInfo.campusId!==-1 ? draftInfo.campusId : undefined,
      schoolYearId: draftInfo.schoolYearId && draftInfo.semesterId ? [draftInfo.schoolYearId===-1?'':draftInfo.schoolYearId, draftInfo.semesterId===-1?'':draftInfo.semesterId] : undefined,
      sectionId: draftInfo.sectionId&&draftInfo.sectionId!==-1 ? draftInfo.sectionId : undefined,
      currentSectionId: draftInfo.currentSectionId&&draftInfo.currentSectionId!==-1 ? draftInfo.currentSectionId : undefined,
      schoolNow: draftInfo.schoolNow ? draftInfo.schoolNow : undefined,
      schoolNowExtra: draftInfo.schoolNowExtra ? draftInfo.schoolNowExtra : undefined,
      schoolBus: draftInfo.schoolBus !== null ? (draftInfo.schoolBus === true ? 'true' : 'false') : undefined,
      boarding: draftInfo.boarding !== null ? (draftInfo.boarding === true ? 'true' : 'false') : undefined,
      english: draftInfo.english ? draftInfo.english : undefined,
      parentEnglishCommunicationFlag:
        draftInfo.parentEnglishCommunicationFlag !== null ? (draftInfo.parentEnglishCommunicationFlag === true ? 'true' : 'false') : undefined,
      interest: draftInfo.interest ? draftInfo.interest : undefined,
      achievement: draftInfo.achievement ? draftInfo.achievement : undefined,
      enterDate: draftInfo.enterDate ? moment(draftInfo.enterDate) : undefined,
      sourceId: draftInfo.sourceId,
      sourceExtra: draftInfo.sourceExtra,
      firstChannel:draftInfo.firstChannel
    };
  },
  formatEnquiryDataInStep1(enquiryData: any) {
    return {
      name: enquiryData.name ? enquiryData.name : undefined,
      enName: enquiryData.enName ? enquiryData.enName : undefined,
      pinyinLastName: enquiryData.pinyinLastName ? enquiryData.pinyinLastName : undefined,
      pinyinFirstName: enquiryData.pinyinFirstName ? enquiryData.pinyinFirstName : undefined,
      gender: enquiryData.gender ? enquiryData.gender : undefined,
      birthday: enquiryData.birthday ? moment(enquiryData.birthday) : undefined,
      idType: enquiryData.idType ? enquiryData.idType : undefined,
      idNumber: enquiryData.idNumber ? enquiryData.idNumber : undefined,
      countryId: enquiryData.countryId ? enquiryData.countryId : undefined,
      address: enquiryData.address ? enquiryData.address : undefined,
      domicileAddress: enquiryData.domicileAddress ? enquiryData.domicileAddress : undefined,
      campusId: enquiryData.campusId && enquiryData.campusId !== -1 ? enquiryData.campusId : undefined,
      schoolYearId: enquiryData.schoolYearId && enquiryData.semesterId ? [enquiryData.schoolYearId === -1 ? '' : enquiryData.schoolYearId, enquiryData.semesterId === -1 ? '' : enquiryData.semesterId] : undefined,
      sectionId: enquiryData.sectionId && enquiryData.sectionId !== -1 ? enquiryData.sectionId : undefined,
      currentSectionId: enquiryData.currentSectionId && enquiryData.currentSectionId !== -1 ? enquiryData.currentSectionId : undefined,
      schoolNow: enquiryData.schoolNow ? enquiryData.schoolNow : undefined,
      schoolNowExtra: enquiryData.schoolNowExtra ? enquiryData.schoolNowExtra : undefined,
      schoolBus: enquiryData.schoolBus !== null ? (enquiryData.schoolBus === true ? 'true' : 'false') : undefined,
      boarding: enquiryData.boarding !== null ? (enquiryData.boarding === true ? 'true' : 'false') : undefined,
      english: enquiryData.english ? enquiryData.english : undefined,
      parentEnglishCommunicationFlag:
        enquiryData.parentEnglishCommunicationFlag !== null ? (enquiryData.parentEnglishCommunicationFlag === true ? 'true' : 'false') : undefined,
      interest: enquiryData.interest ? enquiryData.interest : undefined,
      achievement: enquiryData.achievement ? enquiryData.achievement : undefined,
      enterDate: enquiryData.enterDate ? moment(enquiryData.enterDate) : undefined,
    };
  },
  formatDraftDataInStep2(userInfo: any) {
    const guardianResponse = userInfo.guardianResponse ? userInfo.guardianResponse : {};
    const emergencyContactResponse = userInfo.emergencyContactResponse ? userInfo.emergencyContactResponse : {};
    return {
      mobile: userInfo.mobile || userInfo.accountMobile,
      name: userInfo.name,
      enName: userInfo.enName,
      countryId: userInfo.countryId ? userInfo.countryId : undefined,
      idNumber: userInfo.idNumber ? userInfo.idNumber : undefined,
      relationship: userInfo.relationship ? userInfo.relationship : undefined,
      email: userInfo.email,
      position: userInfo.position,
      workUnit: userInfo.workUnit,
      workAddress: userInfo.workAddress,
      graduatedFrom: userInfo.graduatedFrom,
      highestQualification: userInfo.highestQualification,
      sourceId: userInfo.sourceId,
      sourceExtra: userInfo.sourceExtra,
      guardianName: guardianResponse.name,
      guardianEnName: guardianResponse.enName,
      guardianRelationship: guardianResponse.relationship,
      guardianGender: guardianResponse.gender,
      guardianCountryId: guardianResponse.countryId,
      guardianIdNumber: guardianResponse.idNumber,
      guardianMobile: guardianResponse.mobile,
      guardianWorkUnit: guardianResponse.workUnit,
      guardianWorkAddress: guardianResponse.workAddress,
      guardianPosition: guardianResponse.position,
      guardianEmail: guardianResponse.email,
      guardianGraduatedFrom: guardianResponse.graduatedFrom,
      guardianHighestQualification: guardianResponse.highestQualification,
      emergencyName: emergencyContactResponse.name,
      emergencyRelationship: emergencyContactResponse.relationship,
      emergencyMobile: emergencyContactResponse.mobile,
      emergencyEmail: emergencyContactResponse.email,
    };
  },
  formatGuardianData(values: any) {
    return {
      name: values.guardianName,
      enName: values.guardianEnName,
      mobile: values.guardianMobile,
      relationship: values.guardianRelationship,
      idNumber: values.guardianIdNumber,
      countryId: values.guardianCountryId,
      workUnit: values.guardianWorkUnit,
      workAddress: values.guardianWorkAddress,
      position: values.guardianPosition,
      email: values.guardianEmail.trim(),
      graduatedFrom: values.guardianGraduatedFrom,
      highestQualification: values.guardianHighestQualification,
    };
  },
  formatEmergencyData(values: any) {
    return {
      name: values.emergencyName,
      relationship: values.emergencyRelationship,
      mobile: values.emergencyMobile,
      email: values.emergencyEmail.trim(),
    };
  },
};
